export const ManagerManagementEndpoints = {
  listCommunities: '/manager-management/communities/list',
  listPointsOfSale: '/manager-management/pos/list',
  dashboardMetrics: '/manager-management/dashboard/metrics',
  dashboardChart: '/manager-management/dashboard/chart',
  listBillsToPay: '/manager-management/dashboard/bills-to-pay/list',
  billsToPayExport: '/manager-management/dashboard/bills-to-pay/export',
  listBillsToReceive: '/manager-management/dashboard/bills-to-receive/list',
  billsToReceiveExport: '/manager-management/dashboard/bills-to-receive/export',
  uploadPaymentDoc: (installmentId: string) => `/manager-management/installment/${installmentId}/upload`,
  installmentDetails: (installmentId: string) => `/manager-management/installment/${installmentId}/details`,
  exportReport: '/manager-management/dashboard/export',
};
